import { render } from "./ProfaceConfirmation.vue?vue&type=template&id=474c6c3c&scoped=true"
import script from "./ProfaceConfirmation.vue?vue&type=script&lang=js"
export * from "./ProfaceConfirmation.vue?vue&type=script&lang=js"

import "./ProfaceConfirmation.vue?vue&type=style&index=0&id=474c6c3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474c6c3c"]])

export default __exports__